<template>
    <div class="chat-navbar">
        <!-- {{SingleActiveThreadDetails}} -->
        <div class="nav-chat-details">
            <div v-if="SingleActiveThreadDetails">
                <vs-avatar size="40px" class="border-2 shadow border-solid border-white mr-2 flex-shrink-0" :src="SingleActiveThreadDetails.picture"/>
            </div>
            <div class="">
                <div>
                    <strong>
                    <span v-if="SingleActiveThreadDetails">
                        {{SingleActiveThreadDetails.first_name}} 
                        {{SingleActiveThreadDetails.last_name}}
                    </span>
                    <!-- <span class="mr-2" v-if="groupUsers.length != index + 1">,</span> -->
                    </strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['SingleActiveThreadDetails'],
  computed:{
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  watch () {

  }
    
}
</script>